<template>
  <ol class="cm-documentation__content-list-numbered">
    <li v-for="list in data.content" :key="list" v-html="list" />
  </ol>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.cm-documentation__content-list-numbered {
  list-style-type: decimal;
}
</style>
